import * as React from "react";
import { useCallback } from "react";
import { Formik, Field, useFormikContext } from "formik";
import { Button, Modal } from "components/bootstrap";
import { useModalContext } from "common/contexts";
import { Col, Row } from "common/components/layout-styles";
import { useGetEventProcedure } from "security-app/hooks/useEventProceduresAPI";
import {
  EventProcedureBaseForm,
  ShareFormFormikField,
  validations,
  useFormActions
} from "../plugin/EventProcedureForm";
import { INIT_EVENT_PROCEDURE } from "../plugin/EventProcedureForm/utils";
function Buttons({ isEdit = false, saving }) {
  const { setModal, setEntity } = useModalContext();
  const { resetForm, isValid, dirty, submitForm } = useFormikContext();
  const onCancel = useCallback(() => {
    resetForm();
    setEntity(void 0);
    setModal(void 0);
  }, [resetForm, setEntity, setModal]);
  return /* @__PURE__ */ React.createElement(Row, { $justify: "flex-end" }, /* @__PURE__ */ React.createElement(Button, { type: "reset", onClick: onCancel }, "Cancel"), /* @__PURE__ */ React.createElement(Button, { type: "button", bsStyle: "primary", onClick: submitForm, disabled: !isValid || !dirty || saving }, isEdit ? "Save" : "Create", " Event Procedure"));
}
function EventProcedureModal({ onClose, eventProcedureId = "", isCreate = false }) {
  const { eventProcedure, loadingEventProcedure } = useGetEventProcedure(eventProcedureId);
  const { handleSubmit, saving } = useFormActions();
  const onSubmit = useCallback(
    (inValues) => {
      handleSubmit({ inValues, eventProcedureId });
      onClose();
    },
    [eventProcedureId, handleSubmit, onClose]
  );
  if (loadingEventProcedure) return null;
  return /* @__PURE__ */ React.createElement(Formik, { initialValues: eventProcedure || INIT_EVENT_PROCEDURE, validate: validations, onSubmit }, /* @__PURE__ */ React.createElement(Modal, { show: true, onHide: onClose, bsSize: "lg" }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, `${eventProcedureId ? "Edit" : "Create"} Event Procedure`)), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(EventProcedureBaseForm, null), isCreate && /* @__PURE__ */ React.createElement(
    Field,
    {
      name: "share_request",
      id: "share_request",
      component: ShareFormFormikField,
      description: "Search for a User or Team to add as collaborator on this event procedure.",
      entityType: "event_procedure"
    }
  ))), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(Buttons, { isEdit: !!eventProcedureId, saving }))));
}
export default EventProcedureModal;
